import { styled } from '@mui/material/styles';

export const Table = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  borderRadius: '4px'
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  fontWeight: 'bold'
}));

export const HeaderTime = styled('div')(({ theme }) => ({
  flex: '0 0 30%',
  padding: '8px',
  backgroundColor: theme.palette.neutrals.beige3,
  borderRadius: '8px',
  marginRight: '8px',
  marginBottom: '8px'
}));

export const HeaderEvent = styled('div')(({ theme }) => ({
  flex: '1',
  padding: '8px',
  marginBottom: '8px',
  backgroundColor: theme.palette.neutrals.beige3,
  borderRadius: '8px'
}));

export const Period = styled('div')(({ theme }) => ({
  flex: '0 0 30%',
  display: 'flex',
  marginRight: '8px',
  marginBottom: '8px',
  backgroundColor: theme.palette.neutrals.beige2,
  padding: '25px 15px',
  borderRadius: '8px'
}));

export const Event = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1',
  padding: '25px 15px',
  marginBottom: '8px',
  borderRadius: '8px',
  backgroundColor: theme.palette.neutrals.beige2,
  alignItems: 'flex-start',
  justifyContent: 'space-between'
}));

export const EventDescription = styled('div')(({ theme }) => ({
  paddingRight: theme.spacing(1)
}));

export const EventIcon = styled('div')(() => ({
  height: '41px'
}));

export const DateRow = styled('div')(() => ({
  display: 'flex'
}));

export const EmptyState = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4)
}));
